/**
 * 函数防抖（仅尾调用生效）
 * @param fn
 * @param t delay in ms
 * @returns {Function}
 */
export const DebounceTrailing = (fn, t = 1000) => {
  let timer;
  return function () {
    const context = this;
    const args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(context, args);
      timer = null;
    }, t);
  };
};
